import type {
	DashboardPromoBannerConfig,
	DashPromoGallerySlide,
} from 'src/components/Dashboards/dash-promo-types';
import GenericPromoBanner from 'src/components/Dashboards/DashWidgets/Components/GenericPromoBanner.svelte';

export type MapPromoBannersOptions = {
	/** Compact chrome for GlobalInlineBanners (120px). */
	compact?: boolean;
	maxBanners: number;
};

/**
 * Maps visible promo banner configs into gallery / strip slides.
 * Shared by the dashboard BannersWidget and GlobalInlineBanners.
 */
export const mapPromoBannersToSlides = (
	banners: DashboardPromoBannerConfig[],
	options: MapPromoBannersOptions | number,
): DashPromoGallerySlide[] => {
	const opts: MapPromoBannersOptions =
		typeof options === 'number' ? { maxBanners: options } : options;
	const compact = Boolean(opts.compact);

	return banners
		.filter((banner) => banner.isVisible())
		.slice(0, opts.maxBanners)
		.map((banner): DashPromoGallerySlide => {
			if (banner.kind === 'generic') {
				return {
					id: banner.id,
					component: banner.component ?? GenericPromoBanner,
					dismissable: banner.dismissable !== false,
					onDismiss: banner.onDismiss,
					props: {
						title: banner.title,
						message: banner.message,
						background: banner.background,
						ctaLabel: banner.ctaLabel,
						ctaPosition: banner.ctaPosition ?? 'bottom-left',
						ctaHref: banner.ctaHref,
						onCtaClick: banner.onCtaClick,
						flush: true,
						compact,
						...banner.props,
						compact,
					},
				};
			}

			return {
				id: banner.id,
				component: banner.component!,
				dismissable: banner.dismissable !== false,
				onDismiss: banner.onDismiss,
				// Advanced Verivox banners pick layout via dedicated components (Widget / Inline).
				props: { ...banner.props, dismissable: false },
			};
		});
};
